"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("./styles");

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _componentButton = require("@doordash/component-button");

var _componentSeparator = _interopRequireDefault(require("@doordash/component-separator"));

var _react = _interopRequireDefault(require("react"));

var _types = require("./types");

var _Titles = _interopRequireDefault(require("./Titles"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavBar = function NavBar(_ref) {
  var actions = _ref.actions,
      _ref$isRaised = _ref.isRaised,
      isRaised = _ref$isRaised === void 0 ? false : _ref$isRaised,
      isSeparatorVisibleProp = _ref.isSeparatorVisible,
      _ref$maxNumberOfVisib = _ref.maxNumberOfVisibleActions,
      maxNumberOfVisibleActions = _ref$maxNumberOfVisib === void 0 ? 2 : _ref$maxNumberOfVisib,
      _ref$navigationType = _ref.navigationType,
      navigationType = _ref$navigationType === void 0 ? _constants.NavigationTypes.Back : _ref$navigationType,
      _ref$hasBackButton = _ref.hasBackButton,
      hasBackButton = _ref$hasBackButton === void 0 ? false : _ref$hasBackButton,
      _ref$navigationAlignm = _ref.navigationAlignment,
      navigationAlignmentProp = _ref$navigationAlignm === void 0 ? _types.NavigationAlignments.Leading : _ref$navigationAlignm,
      noContentPadding = _ref.noContentPadding,
      onNavigationClick = _ref.onNavigationClick,
      onBackButtonClick = _ref.onBackButtonClick,
      onOverflowClick = _ref.onOverflowClick,
      parentTitle = _ref.parentTitle,
      subtext = _ref.subtext,
      _ref$strings = _ref.strings,
      strings = _ref$strings === void 0 ? {} : _ref$strings,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? _designLanguage.Text.TextAlignments.Left : _ref$textAlign,
      title = _ref.title,
      _ref$titleSize = _ref.titleSize,
      titleSize = _ref$titleSize === void 0 ? _types.TitleSizes.Small : _ref$titleSize,
      shouldRenderTitleOnNewLine = _ref.shouldRenderTitleOnNewLine;
  // Subtext setup
  var subtextStringToDisplay = parentTitle || subtext;
  var isSubtextFirst = !!(parentTitle && typeof parentTitle !== 'undefined'); // Title setup

  var hasSmallTitle = titleSize === _types.TitleSizes.Small;
  var displayTitleBelow = (0, _utils.getShouldRenderTitleBelow)({
    hasSmallTitle: hasSmallTitle,
    shouldRenderTitleOnNewLine: shouldRenderTitleOnNewLine,
    navigationAlignment: navigationAlignmentProp
  }); // Layout setup

  var isSquished = displayTitleBelow || !!(parentTitle && typeof parentTitle !== 'undefined') || !!(subtext && typeof subtext !== 'undefined');
  var isSeparatorVisible = typeof isSeparatorVisibleProp === 'boolean' ? isSeparatorVisibleProp : !displayTitleBelow && !isRaised; // Navigation setup

  var hasNavigationItem = navigationType !== _constants.NavigationTypes.None;
  var navigationAlignment = hasBackButton ? _types.NavigationAlignments.Trailing : navigationAlignmentProp;

  var _getShouldRenderActio = (0, _utils.getShouldRenderActionContainers)({
    actions: actions,
    hasBackButton: hasBackButton,
    hasNavigationItem: hasNavigationItem,
    navigationAlignment: navigationAlignment
  }),
      renderLeadingActionContainer = _getShouldRenderActio.renderLeadingActionContainer,
      renderTrailingActionContainer = _getShouldRenderActio.renderTrailingActionContainer; // Navigation/Back Button setup


  var navigationConfig = {
    type: typeof navigationType !== 'string' && navigationType.icon,
    onClick: typeof onNavigationClick === 'function' ? onNavigationClick : undefined,
    accessibilityLabel: strings && strings.navigationButtonLabel || typeof navigationType !== 'string' && navigationType.accessibilityLabel
  };
  var backButtonConfig = {
    type: _componentButton.IconButton.IconTypes.ArrowLeft,
    onClick: typeof onBackButtonClick === 'function' ? onBackButtonClick : undefined,
    accessibilityLabel: strings.backButtonLabel || _constants.NavigationTypes.Back.accessibilityLabel
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.NavBarContainer, {
    isRaised: isRaised
  }, /*#__PURE__*/_react["default"].createElement(_styles.UpperNavBarContainer, {
    noContentPadding: noContentPadding,
    isSquished: isSquished,
    displayTitleBelow: displayTitleBelow
  }, renderLeadingActionContainer && /*#__PURE__*/_react["default"].createElement(_styles.ActionsContainer, {
    noContentPadding: noContentPadding
  }, navigationAlignment === _types.NavigationAlignments.Leading && hasNavigationItem && /*#__PURE__*/_react["default"].createElement(_styles.ActionWrapper, null, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, {
    iconType: navigationConfig.type,
    onClick: navigationConfig.onClick,
    accessibilityLabel: navigationConfig.accessibilityLabel
  })), hasBackButton && /*#__PURE__*/_react["default"].createElement(_styles.ActionWrapper, null, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, {
    iconType: backButtonConfig.type,
    onClick: backButtonConfig.onClick,
    accessibilityLabel: backButtonConfig.accessibilityLabel
  }))), /*#__PURE__*/_react["default"].createElement(_styles.TitleContainer, null, !displayTitleBelow && /*#__PURE__*/_react["default"].createElement(_Titles["default"], {
    isSubtextFirst: isSubtextFirst,
    textAlign: textAlign,
    hasSmallTitle: hasSmallTitle,
    subtextStringToDisplay: subtextStringToDisplay,
    title: title
  })), renderTrailingActionContainer && /*#__PURE__*/_react["default"].createElement(_styles.ActionsContainer, {
    noContentPadding: noContentPadding
  }, actions && actions.length > 0 ? actions.slice(0, maxNumberOfVisibleActions).map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_styles.ActionWrapper, {
      key: action.accessibilityLabel
    }, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, action));
  }) : undefined, actions && actions.length > maxNumberOfVisibleActions && onOverflowClick && /*#__PURE__*/_react["default"].createElement(_styles.ActionWrapper, {
    key: "overflow"
  }, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, {
    onClick: function onClick(event) {
      return onOverflowClick(actions.slice(maxNumberOfVisibleActions), event);
    },
    accessibilityLabel: "Other Actions",
    iconType: _componentButton.IconButton.IconTypes.MoreHorizontal
  })), navigationAlignment === _types.NavigationAlignments.Trailing && hasNavigationItem && /*#__PURE__*/_react["default"].createElement(_styles.ActionWrapper, null, /*#__PURE__*/_react["default"].createElement(_componentButton.IconButton, {
    iconType: navigationConfig.type,
    onClick: navigationConfig.onClick,
    accessibilityLabel: navigationConfig.accessibilityLabel
  })))), displayTitleBelow && /*#__PURE__*/_react["default"].createElement(_styles.LowerNavBarContainer, {
    noContentPadding: noContentPadding
  }, /*#__PURE__*/_react["default"].createElement(_Titles["default"], {
    isSubtextFirst: isSubtextFirst,
    textAlign: textAlign,
    hasSmallTitle: hasSmallTitle,
    subtextStringToDisplay: subtextStringToDisplay,
    title: title,
    isBelow: true
  })), isSeparatorVisible && /*#__PURE__*/_react["default"].createElement(_componentSeparator["default"], {
    type: _componentSeparator["default"].Types.FullBorder
  }));
};

NavBar.TextAlignments = _constants.TextAlignments;
NavBar.TitleSizes = _types.TitleSizes;
NavBar.NavigationTypes = _constants.NavigationTypes;
NavBar.NavigationAlignments = _types.NavigationAlignments;
var _default = NavBar;
exports["default"] = _default;